import { create } from 'zustand';

// Tipo local para evitar dependencia circular con auth.actions.ts
interface LoginData {
  username: string;
  password: string;
  forzar?: boolean;
  empresa?: string;
  nombre_comercial?: string;
}

export type DosFactorLoginMetodo = 'email' | 'app';

interface DosFactorLoginStore {
  isOpen: boolean;
  challengeToken: string | null;
  metodo: DosFactorLoginMetodo | null;
  emailMascarado: string | null;
  // Estado del envío inicial del correo (solo aplica si metodo='email').
  // Si fue false, el dialog muestra un warning prominente con el error real.
  emailEnvioOk: boolean | null;
  emailEnvioError: string | null;
  loginData: LoginData | null; // credenciales originales (para permitir "forzar" luego)

  open: (params: {
    challengeToken: string;
    metodo: DosFactorLoginMetodo;
    emailMascarado?: string | null;
    emailEnvioOk?: boolean | null;
    emailEnvioError?: string | null;
    loginData: LoginData;
  }) => void;
  close: () => void;
  setEmailEnvioOk: (ok: boolean, err?: string | null) => void;
}

export const useDosFactorLogin = create<DosFactorLoginStore>()(set => ({
  isOpen: false,
  challengeToken: null,
  metodo: null,
  emailMascarado: null,
  emailEnvioOk: null,
  emailEnvioError: null,
  loginData: null,

  open: ({ challengeToken, metodo, emailMascarado = null, emailEnvioOk = null, emailEnvioError = null, loginData }) =>
    set({
      isOpen: true,
      challengeToken,
      metodo,
      emailMascarado,
      emailEnvioOk,
      emailEnvioError,
      loginData,
    }),

  close: () =>
    set({
      isOpen: false,
      challengeToken: null,
      metodo: null,
      emailMascarado: null,
      emailEnvioOk: null,
      emailEnvioError: null,
      loginData: null,
    }),

  setEmailEnvioOk: (ok, err = null) =>
    set({ emailEnvioOk: ok, emailEnvioError: err }),
}));
